<template>
  <form
    id="project-form"
    @submit="checkForm"
    action="#"
    method="post"
    novalidate="true"
  >
    <div class="form-item">
      <label class="required" for="project-name">{{
        $t("group.projectForm.projectName")
      }}</label>
      <p v-if="errProjectName && projectName.length > 30" class="error">
        {{ $t("group.projectForm.errorMsg.projectName") }}
      </p>
      <p v-if="errSurrogatePair" class="error">
        {{ $t("group.projectForm.errorMsg.surrogatePair") }}
      </p>
      <input
        id="project-name"
        name="project-name"
        maxlength="30"
        v-model="projectName"
        v-on:input="
          updateForm = true;
          errProjectName = false;
          errSurrogatePair = false;
          invalidProjectName = false;
        "
        v-bind:class="{
          error: errProjectName || errSurrogatePair || invalidProjectName,
        }"
      />
      <p v-if="errProjectName" class="error errorMsg">
        {{ $t("group.projectForm.errorMsg.noProjectName") }}
      </p>
      <p v-if="invalidProjectName" class="error errorMsg">
        {{ $t("group.projectForm.errorMsg.invalidProjectName") }}
      </p>
      <span
        v-bind:class="{ 'char-count': true, error: projectName.length > 30 }"
      >
        {{ projectName.length }} / 30
      </span>
    </div>

    <div class="form-item">
      <label class="" for="project-summary">{{
        $t("group.projectForm.projectSummary")
      }}</label>
      <p v-if="errProjectSummary && projectSummary.length > 300" class="error">
        {{ $t("group.projectForm.errorMsg.projectSummary") }}
      </p>
      <textarea
        id="project-summary"
        name="project-summary"
        rows="4"
        maxlength="300"
        v-model="projectSummary"
        v-on:input="updateForm = true"
        v-bind:class="{ error: errProjectSummary }"
      ></textarea>
      <span
        v-bind:class="{
          'char-count': true,
          error: projectSummary.length > 300,
        }"
      >
        {{ projectSummary.length }} / 300
      </span>
    </div>

    <input
      type="submit"
      class="submit"
      v-bind:value="$t('group.projectForm.button.create')"
    />
  </form>
</template>

<script>
import { validSurrogatePair } from "@/utils/validSurrogatePair";
import { validFileInclusion } from "@/utils/validFileInclusion";
import { groupService } from "@/services/group.service";

export default {
  props: ["groupId"],
  name: "ProjectForm",
  data() {
    //let user = JSON.parse(localStorage.getItem('user'))
    return {
      invalidForm: true,
      invalidProjectName: false,

      errProjectName: false,
      errSurrogatePair: false,
      errProjectSummary: false,

      projectName: "",
      projectSummary: "",
    };
  },
  created: function() {
    //console.log(this.groupId)
  },
  methods: {
    checkForm: function(event) {
      this.invalidForm = false;
      this.errProjectName = false;
      this.errSurrogatePair = false;
      this.errProjectSummary = false;

      if (this.projectName === "") {
        this.invalidForm = true;
        this.errProjectName = true;
      }

      if (
        this.projectName.length > 30 ||
        validFileInclusion(this.projectName)
      ) {
        this.invalidForm = true;
        this.invalidProjectName = true;
      }

      if (validSurrogatePair(this.projectName)) {
        this.invalidForm = true;
        this.errSurrogatePair = true;
      }

      if (this.projectSummary.length > 300) {
        this.invalidForm = true;
        this.errProjectSummary = true;
      }

      if (!this.invalidForm) {
        this.createProject();
      }

      event.preventDefault();
    },
    createProject: function() {
      let newProject = {
        description: btoa(encodeURIComponent(this.projectSummary)),
        name: this.projectName,
      };

      groupService
        .createProject(this.groupId, newProject)
        .then(() => {
          //console.log('called group create ', res)
          this.$router.go(0);
        })
        .catch((err) => {
          console.error("Unable to Create Project: ", err);
        });
    },
  },
};
</script>
<style lang="scss">
.modal-body {
  color: $text-dark;
  padding: 40px 40px 0;

  #project-form {
    padding: 20px 0;
  }
}

#project-form {
  .form-item {
    position: relative;
    .char-count {
      position: absolute;
      right: 0;
      bottom: 5px;
    }
  }

  input.submit {
    @extend button;
    margin-top: 0;
    width: auto;
  }
  .auth-req {
    margin-top: 15px;
    padding-top: 30px;
    border-top: 2px solid #ccc;
  }
}
</style>
